export default __webpack_public_path__ + "static/media/gallery_16.7d7f0b93.jpg";